import { createContext, useContext } from 'react';
import type { ClusterDetailsContextType } from './types';

export const ClusterDetailsContext = createContext<ClusterDetailsContextType>({
  activeInstallationId: '',
  setActiveInstallation: () => {},
});

export const useClusterDetailsContext = () => useContext(ClusterDetailsContext);
